import Handlebars from 'handlebars/runtime';

slideshare_object.utils.exports(
  'templates.clipping.success-toast',
  Handlebars.template({
    compiler: [6, '>= 2.0.0-beta.1'],
    main: function (depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = this.lambda,
        alias2 = this.escapeExpression;

      return (
        '<a href="' +
        alias2(
          alias1(
            (stack1 = depth0 != null ? depth0.clipboard : depth0) != null
              ? stack1.url
              : stack1,
            depth0
          )
        ) +
        '">\n  <span class="slide-thumb" style="background-image: url(\'' +
        alias2(
          alias1(
            (stack1 = depth0 != null ? depth0.clip : depth0) != null
              ? stack1.thumbnail
              : stack1,
            depth0
          )
        ) +
        '\');"></span>\n</a>\n<p class="details">\n  ' +
        ((stack1 =
          ((helper =
            (helper =
              helpers.message || (depth0 != null ? depth0.message : depth0)) !=
            null
              ? helper
              : helpers.helperMissing),
          typeof helper === 'function'
            ? helper.call(depth0, { name: 'message', hash: {}, data: data })
            : helper)) != null
          ? stack1
          : '') +
        '\n</p>\n<div class="toast-actions">\n  <button class="change j-change-clipboard">' +
        alias2(
          alias1(
            (stack1 =
              (stack1 =
                (stack1 = depth0 != null ? depth0.i18n : depth0) != null
                  ? stack1.clipping
                  : stack1) != null
                ? stack1.toast
                : stack1) != null
              ? stack1.change_clipboard
              : stack1,
            depth0
          )
        ) +
        '</button>\n  <button class="share j-share-clip">\n    <i class="fa fa-fw fa-share" aria-hidden="true"></i> ' +
        alias2(
          alias1(
            (stack1 =
              (stack1 =
                (stack1 = depth0 != null ? depth0.i18n : depth0) != null
                  ? stack1.clipping
                  : stack1) != null
                ? stack1.toast
                : stack1) != null
              ? stack1.share_clip
              : stack1,
            depth0
          )
        ) +
        '\n  </button>\n</div>\n'
      );
    },
    useData: true,
  })
);
